import React from 'react';
import DeleteRoomModal from './modals/DeleteRoomModal';
import CreateCommunityChannelModal from './components/DamzHeader/CreateCommunityChannelModal/Loadable';
import ReportMessageSpamModal from './modals/ReportMessageSpamModal';
import ReportSpamDoneModal from './modals/ReportSpamDoneModal';
import RenameRoomModal from './modals/RenameRoomModal';
import BannedUserModal from './modals/BannedUserModal';
import CommunityChannelFullModal from './modals/CommunityChannelFullModal';
import UpsellToAddUsersModal from './modals/UpsellToAddUsersModal';

export const MODAL_TYPES = {
  DELETE_ROOM: 'DELETE_ROOM',
  CREATE_COMMUNITY_CHANNEL: 'CREATE_COMMUNITY_CHANNEL',
  MESSAGE_SPAM: 'MESSAGE_SPAM',
  REPORT_SPAM_DONE: 'REPORT_SPAM_DONE',
  RENAME_ROOM: 'RENAME_ROOM',
  BANNED_USER_MODAL: 'BANNED_USER_MODAL',
  COMMUNITY_CHANNEL_FULL: 'COMMUNITY_CHANNEL_FULL',
  ADD_USER_NEEDS_UPGRADE: 'ADD_USER_NEEDS_UPGRADE',
};

/**
 * Make sure all modals are lazy loaded if adding new ones, this will be included in every
 * propjects main bundle otherwise.
 */
export const damzModalRenderer = (
  modalType: string,
  requestClose: () => void,
  params?: any
) => {
  switch (modalType) {
    case MODAL_TYPES.DELETE_ROOM:
      return (
        <DeleteRoomModal
          requestClose={requestClose}
          room_id={params.room_id}
          roomType={params.roomType}
          isOwner={params.isOwner}
          isDelete={params.isDelete}
        />
      );
    case MODAL_TYPES.CREATE_COMMUNITY_CHANNEL:
      return <CreateCommunityChannelModal onRequestClose={requestClose} />;
    case MODAL_TYPES.MESSAGE_SPAM:
      return (
        <ReportMessageSpamModal
          requestClose={requestClose}
          message_id={params.message_id}
          room_id={params.room_id}
        />
      );
    case MODAL_TYPES.REPORT_SPAM_DONE:
      return (
        <ReportSpamDoneModal requestClose={requestClose} user={params.user} />
      );
    case MODAL_TYPES.RENAME_ROOM:
      return (
        <RenameRoomModal
          requestClose={requestClose}
          room_id={params.room_id}
          roomType={params.roomType}
          currentName={params.currentName}
        />
      );
    case MODAL_TYPES.BANNED_USER_MODAL:
      return (
        <BannedUserModal
          requestClose={requestClose}
          room_id={params.room_id}
          bannedUser={params.bannedUser}
        />
      );
    case MODAL_TYPES.COMMUNITY_CHANNEL_FULL:
      return <CommunityChannelFullModal requestClose={requestClose} />;
    case MODAL_TYPES.ADD_USER_NEEDS_UPGRADE:
      return <UpsellToAddUsersModal requestClose={requestClose} />;
    default:
      return null;
  }
};

export default damzModalRenderer;
